/**
 * Formate les dates de réapprovisionnement ("De retour le …") dans la langue
 * réelle du storefront (lue sur <html lang>), via l'API Intl native.
 *
 * Côté Liquid on rend uniquement la date ISO dans <time datetime="YYYY-MM-DD"
 * data-restock-date>…</time> ; ce script la remplace par une date localisée.
 * Un MutationObserver couvre les contenus injectés dynamiquement (changement
 * de variante sur la fiche produit, filtres AJAX de collection, quick add).
 */
(function () {
  var DATE_OPTIONS = { day: 'numeric', month: 'long', year: 'numeric' };

  function format(el) {
    if (el.dataset.restockFormatted) return;
    var iso = el.getAttribute('datetime');
    if (!iso) return;
    // Midi pour éviter tout décalage de fuseau horaire sur une date seule.
    var date = new Date(iso + 'T12:00:00');
    if (isNaN(date.getTime())) return;

    var locale = document.documentElement.lang || undefined;
    try {
      el.textContent = date.toLocaleDateString(locale, DATE_OPTIONS);
    } catch (e) {
      el.textContent = date.toLocaleDateString(undefined, DATE_OPTIONS);
    }
    el.dataset.restockFormatted = 'true';
  }

  function formatWithin(root) {
    var nodes = (root || document).querySelectorAll(
      'time[data-restock-date]:not([data-restock-formatted])'
    );
    for (var i = 0; i < nodes.length; i++) format(nodes[i]);
  }

  function init() {
    formatWithin(document);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('time[data-restock-date]')) format(node);
          else if (node.querySelector) formatWithin(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
